import {EditOutlined} from '@mui/icons-material'
import {Alert, Button, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {RUNNING_TIMES_WIDGET_NAMESPACE} from '../consts'

type Props = {
  stoppagesCount: number
  handleOpen: () => void
}

export const MissingStoppageAlert = ({stoppagesCount, handleOpen}: Props) => {
  const {t} = useTranslation(RUNNING_TIMES_WIDGET_NAMESPACE)

  return (
    <Alert
      sx={{
        '& .MuiAlert-message': {alignContent: 'center'},
        marginBottom: 1
      }}
      icon={false}
      severity="info"
      data-test-id="missing-stoppage-alert"
      action={
        <Button
          variant="text"
          startIcon={<EditOutlined fontSize="small" />}
          size="small"
          data-test-id="equipment-fill-info-button"
          onClick={(e) => {
            e.stopPropagation()
            handleOpen()
          }}
        >
          {t('missingStoppageAlert.message.fillInformation')}
        </Button>
      }
    >
      <Typography variant="caption" display="flex" gap={2}>
        {t('missingStoppageAlert.message.missingStoppage', {
          count: stoppagesCount
        })}
      </Typography>
    </Alert>
  )
}
